module.exports = __webpack_public_path__ + "img/lime.bf99007c.svg";